import { render } from "./ReviewCollection.vue?vue&type=template&id=5db7b700"
import script from "./ReviewCollection.vue?vue&type=script&lang=js"
export * from "./ReviewCollection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__